import { getStore } from '../store/Store';
import { action } from 'satcheljs/lib/legacy';
export default action('setTypeOfItemBeingDragged')(function setTypeOfItemBeingDragged(dataItemType) {
    var store = getStore();
    store.typeOfItemBeingDragged = dataItemType;
});
//# sourceMappingURL=setTypeOfItemBeingDragged.js.map